<script setup lang="ts">
import { RouterLink } from 'vue-router'
import { useAuthStore } from '../stores/auth'
import rwpLogo from '../../assets/svg/rwp-logo.svg?raw'
import CLoginButton from './CLoginButton.vue'
import hangarApiLogo from '../../assets/svg/hangar-api-logo.svg?raw'

const auth = useAuthStore()
</script>

<template>
	<body class="l-stack--lg">
		<header class="g-header">
			<nav class="g-nav l-row">
				<ul class="g-nav__group">
					<li>
						<RouterLink class="g-nav__title" to="/">Hangar API</RouterLink>
					</li>
					<li><RouterLink to="/">Home</RouterLink></li>
					<li><RouterLink to="/competitions">Competitions</RouterLink></li>
					<li v-if="auth.user"><RouterLink to="/profile">Profile</RouterLink></li>
				</ul>
				<div v-if="!auth.user" class="g-nav__group">
					<c-login-button/>
				</div>
			</nav>
		</header>

		<div class="g-content">
			<slot />
		</div>

		<footer class="g-footer l-stack">
			<div class="l-row l-flex">
				<section class="g-footer__logos l-flex" style="gap: 1rem;">
					<!-- eslint-disable-next-line vue/no-v-html -->
					<span v-html="hangarApiLogo" />
					<!-- eslint-disable-next-line vue/no-v-html -->
					<span v-html="rwpLogo" />
				</section>
				<section>
					<a href="https://discord.gg/czpYcVHK">Join us on Discord</a>
				</section>
			</div>

			<div class="l-row g-footer__copypasta">
				The only problem with my Hornet (and of course, it is a perfect plane, a perfect plane in every way, it's the best plane I ever saw) is (and it obviously has a few small problems, of course, that's to be expected, but it's perfect, perfect in every way, absolutely the fastest and best plane ever made, and we have the best planes here, of course, you'd think the german or russian planes are better, but no, our planes are the best, and my Hornet is the best of all of them) the fuel (and of course, the fuel is top quality, made by Americans) drain shifts the COM slightly, so that the peak performance is right at the end of the fuel gauge.
			</div>

			<div class="l-row">
				Looking for something else? | <RouterLink to="/pizza">Order a Pizza</RouterLink>
			</div>
		</footer>
	</body>
</template>
